import React from 'react';
import { ShieldOff } from 'lucide-react';

export default function NoAccessFallback({ feature }) {
  return (
    <div className="card" style={{ maxWidth: 600, margin: '40px auto', padding: 48, textAlign: 'center' }}>
      <div style={{ width: 64, height: 64, background: '#fef2f2', borderRadius: 16, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px', border: '1px solid #fecaca' }}>
        <ShieldOff size={28} color="#dc2626" />
      </div>
      <h2 style={{ fontSize: 18, fontWeight: 900, color: '#0f172a', marginBottom: 8 }}>Access Restricted</h2>
      <p style={{ fontSize: 12, color: '#64748b', lineHeight: 1.7, marginBottom: 16 }}>
        <strong>{feature}</strong> is reserved for Super Admin only. Please contact <code style={{ background: '#f1f5f9', padding: '1px 6px', borderRadius: 4 }}>msivan@myaccounts.in</code> for access.
      </p>
      <span className="badge badge-red">SUPER ADMIN REQUIRED</span>
    </div>
  );
}
